"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configuracoesPorTipo = exports.TipoInputNumerico = void 0;
exports.TipoInputNumerico = {
    Padrao: "padrao",
    Monetario: "monetario",
    Metragem: "metragem",
};
exports.configuracoesPorTipo = {
    padrao: { casasDecimais: 3, exibirMilhar: false },
    monetario: { casasDecimais: 2, exibirMilhar: true },
    metragem: { casasDecimais: 2, exibirMilhar: true },
};
